import type { Meta, StoryObj } from "@storybook/react";
import { MaintenanceScreen } from "../../screens/MaintenanceScreen";

// Simulates a check of the server that takes a moment, so the Retry button shows its loader.
const onRetry = () => new Promise<void>((resolve) => setTimeout(resolve, 1500));

const meta = {
    title: "Screens/Maintenance",
    component: MaintenanceScreen,
    args: { onRetry },
} satisfies Meta<typeof MaintenanceScreen>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
